__turbopack_context__.v({
  "Blank": "Header-module__5Szj_G__Blank",
  "Header": "Header-module__5Szj_G__Header",
});
